{
    "DisplayasoptionsGrid": "Rede",
    "DisplayasoptionsColumns": "Colunas",
    "DisplayasoptionsRows": "Linhas",
    "DisplayasoptionsChart": "Gráfico",
    "DisplayasoptionsDetailedtableview": "Visualização de tabela detalhada",
    "DisplayasoptionsBlfviewhorizontal": "Visualização BLF (Horizontal)",
    "DisplayasoptionsBlfviewvertical": "Visualização BLF (Vertical)",
    "DisplayasoptionsChartview": "Visualização de gráfico",
    "NAME": "DisplayedAsOptions"
}